import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=2b171b97&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=2b171b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b171b97",
  null
  
)

export default component.exports